export default "__VITE_ASSET__sZGSrcQX__"